// Отправить запрос на сервер.

import {get} from '~/app/utils/ServerApi';
import {StateFilter, StateListData, StateListDataItem} from '../Store/State';

/**
 * Отправить запрос на сервер.
 * 
 * @param query Строка запроса.
 * @returns Новый объект состояния.
 */
async function sendListRequest( query: string = '' ): Promise<ServerNormalizedResponse>
{
	const response = await get<ServerResponse>(
		'/choose/apartment/?ajax=1' + ( query ? '&' + query : '' ),
	);
	const items = response.items.map(
		(
			{
				id, section, floor, room_type, square_total, total_cost,
				image,
			}: ServerResponseItem,
		): StateListDataItem =>
		{
			return {
				id,
				section,
				floor,
				roomType: room_type,
				squareTotal: square_total,
				totalCost: total_cost,
				image,
			};
		},
	);
	
	return {
		filter: response.filter,
		listData: {
			items,
			itemsLeft: response.rowsLeft,
			nextItemsOffset: response.offset + response.limit,
		},
	};
}

/**
 * Ответ сервера.
 */
interface ServerResponse
{
	/** Результат выборки */
	items: ServerResponseItem[];
	/** Описание полей фильтра */
	filter: StateFilter;
	/** Общее количество найденных записей */
	rowsTotal: number;
	/** Сколько осталось незагруженных записей */
	rowsLeft: number;
	/** Текущее ограничение на количество записей в ответе */
	limit: number;
	/** Текущее смещение результата выборки */
	offset: number;
}

/**
 * Объект квартиры с сервера.
 */
interface ServerResponseItem
{
	/** ID в базе */
	id: number;
	/** Секция */
	section: string;
	/** Этаж */
	floor: number;
	/** Тип комнат */
	room_type: string;
	/** Общая площадь, м² */
	square_total: number;
	/** Общая цена */
	total_cost: number;
	/** Файл планировки квартиры */
	image: string;
}

/**
 * Нормальзованный ответ сервера.
 */
interface ServerNormalizedResponse
{
	/** Описание полей фильтра */
	filter: StateFilter;
	/** Состояние режима списка */
	listData: Partial<StateListData>;
}

/**
 * Module.
 */
export {
	sendListRequest as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/sendListRequest.ts